export default "__VITE_ASSET__Bdna4sSl__"